module.exports = __webpack_public_path__ + "img/url-background.38656139.png";